export const SUPER_ADMIN_EMAILS = [
  "nick@cynethealth.com",
  "nick@cynetcorp.com",
  "pushpendra.y@cynetcorp.com",
  "pushpendra.y@cynethealth.com",
  "nb@cynetsystems.com",
  "nick@cynetsystems.com",
  "nb@cynetcorp.com",
  "nb@cynethealth.com",
  "nick@cynethealth.ca",
  "nick@cynetlocums.com",
  "raj@cynetsystems.com",
];

export function isSuperAdminEmail(email) {
  const normalized = String(email || "").toLowerCase().trim();
  if (!normalized) return false;
  return SUPER_ADMIN_EMAILS.some((item) => item.toLowerCase() === normalized);
}
